import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import AbstractFormComponent from 'components/form/AbstractFormComponent';
import { SecurityContext } from 'utils';

import ApiConstants from 'PMT/constants/ApiConstants';

export default class AbstractOrderSettingsForm extends AbstractFormComponent {

  componentWillReceiveProps(nextProps) {
    if (!this.props.orderSettings.equals(nextProps.orderSettings)) {
      // orderSettings have changed, we reset the form.
      this.setState(this.getDefaultState(nextProps.orderSettings));
    }
  }

  get restaurant(): Restaurant {
    return this.props.restaurant;
  }

  get orderSettings(): OrderSettings {
    return this.state.orderSettings;
  }

  canReadSettings(): boolean {
    return SecurityContext.orderSettings.canRead();
  }

  canEditSettings(): boolean {
    return SecurityContext.orderSettings.canEdit();
  }

  // -- events

  onChangeOrderSettings = (orderSettings: OrderSettings) => {
    this.setState({
      orderSettings
    });
  }

  onReset = () => {
    this.setState(this.getDefaultState(this.props.orderSettings));
  };

  getDefaultState(orderSettings: OrderSettings): Object {
    return {
      orderSettings: orderSettings.copy()
    };
  }

  haveModifications(): boolean {
    return !this.props.orderSettings.equals(this.orderSettings);
  }

  shouldDisableSubmit(): boolean {
    return !this.canEditSettings();
  }

  onSubmit = (event: Event) => {
    if (this.canEditSettings()) {
      this.props.onSubmit(this.orderSettings);
    }
  };

  /**
   * TODO: refactor with bitfield when it will be implemented on API
   * TODO: if number of payment methods increase, we need to review
   *       the way to define the default one
   */
  onPaymentMethodsChange = (value: number, modeSettings: object) => {
    if (modeSettings.havePaymentMethodAllowed(value)) {
      modeSettings.paymentMethodsAllowed -= value;
    } else {
      modeSettings.paymentMethodsAllowed += value;
    }

    if (modeSettings.paymentMethodsAllowed === 0) {
      modeSettings.paymentMethodsAllowed = value == ApiConstants.OrderPaymentMethodsAllowed.IRL ?
        ApiConstants.OrderPaymentMethodsAllowed.CREDIT_CARD :
        ApiConstants.OrderPaymentMethodsAllowed.IRL;
    }

    this.onChangeOrderSettings(this.orderSettings);
  }

}
